/* ============================================================
   UNVEXT — Main JavaScript
   Vanilla JS — zero dependencies
   ============================================================ */

(function () {
  'use strict';

  /* Promotional popup */
  const promoPopup = document.getElementById('promo-popup');
  if (promoPopup && promoPopup.dataset) {
    const promoFrequency = promoPopup.dataset.frequency || 'once_per_day';
    const promoTrigger = promoPopup.dataset.trigger || 'delay';
    const promoDelay = parseInt(promoPopup.dataset.delay || '5', 10);
    const promoScrollPct = parseInt(promoPopup.dataset.scrollThreshold || '30', 10);
    const PROMO_KEY = promoPopup.dataset.storageKey || 'unvext_promo_popup';

    function promoShouldShow() {
      if (sessionStorage.getItem(PROMO_KEY)) return false;
      let stored = {};
      try { stored = JSON.parse(localStorage.getItem(PROMO_KEY) || '{}'); } catch (e) {}
      if (stored.dismissedUntil && stored.dismissedUntil > Date.now()) return false;
      return true;
    }

    function promoRecordDismissal() {
      const now = Date.now();
      switch (promoFrequency) {
        case 'every_visit':
          return;
        case 'once_per_session':
          sessionStorage.setItem(PROMO_KEY, '1');
          return;
        case 'once_per_day':
          localStorage.setItem(PROMO_KEY, JSON.stringify({ dismissedAt: now, dismissedUntil: now + 86400000 }));
          return;
        case 'once_per_week':
          localStorage.setItem(PROMO_KEY, JSON.stringify({ dismissedAt: now, dismissedUntil: now + 604800000 }));
          return;
        case 'once_per_month':
          localStorage.setItem(PROMO_KEY, JSON.stringify({ dismissedAt: now, dismissedUntil: now + 2592000000 }));
          return;
        case 'once_ever':
          localStorage.setItem(PROMO_KEY, JSON.stringify({ dismissedAt: now, dismissedUntil: Number.MAX_SAFE_INTEGER }));
          return;
      }
    }

    function promoOpen() {
      if (promoPopup.open) return;
      if (typeof promoPopup.showModal === 'function') {
        promoPopup.showModal();
      } else {
        promoPopup.setAttribute('open', '');
      }
    }

    function promoClose() {
      promoRecordDismissal();
      if (typeof promoPopup.close === 'function') {
        promoPopup.close();
      } else {
        promoPopup.removeAttribute('open');
      }
    }

    promoPopup.querySelectorAll('[data-promo-close]').forEach(function (btn) {
      btn.addEventListener('click', promoClose);
    });
    promoPopup.addEventListener('cancel', promoRecordDismissal);

    promoPopup.addEventListener('click', function (e) {
      const rect = promoPopup.getBoundingClientRect();
      const inside =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;
      if (!inside) promoClose();
    });

    // After a newsletter form submit the page reloads — force the popup
    // open so the visitor sees the success / error message.
    const promoFormResult = promoPopup.querySelector('[data-promo-form-result]');

    if (promoFormResult) {
      promoOpen();
      if (promoFormResult.getAttribute('data-promo-form-result') === 'success') {
        // They subscribed — don't nag them with the popup again.
        promoRecordDismissal();
      }
    } else if (promoShouldShow()) {
      if (promoTrigger === 'immediate') {
        promoOpen();
      } else if (promoTrigger === 'delay') {
        setTimeout(promoOpen, promoDelay * 1000);
      } else if (promoTrigger === 'scroll') {
        const onPromoScroll = function () {
          const max = document.documentElement.scrollHeight - window.innerHeight;
          if (max <= 0) return;
          const scrolled = (window.scrollY / max) * 100;
          if (scrolled >= promoScrollPct) {
            window.removeEventListener('scroll', onPromoScroll);
            promoOpen();
          }
        };
        window.addEventListener('scroll', onPromoScroll, { passive: true });
      } else if (promoTrigger === 'exit_intent') {
        let promoArmed = false;
        setTimeout(function () { promoArmed = true; }, 3000);
        document.addEventListener('mouseleave', function (e) {
          if (promoArmed && e.clientY <= 0 && !promoPopup.open) promoOpen();
        });
      }
    }
  }

  /* Menu system */
  const menuOverlay  = document.querySelector('.menu-overlay');
  const menuTriggers = document.querySelectorAll('.header__menu-trigger, .header__hamburger');
  const menuClose    = document.querySelector('.menu-overlay__close');
  const menuLinks    = document.querySelectorAll('.menu-overlay a');

  function openMenu() {
    if (!menuOverlay) return;
    menuOverlay.classList.add('is-open');
    document.body.classList.add('menu-open');
    menuOverlay.setAttribute('aria-hidden', 'false');
    const firstFocusable = menuOverlay.querySelector('button, a');
    if (firstFocusable) firstFocusable.focus({ preventScroll: true });
  }

  function closeMenu() {
    if (!menuOverlay) return;
    menuOverlay.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    menuOverlay.setAttribute('aria-hidden', 'true');
  }

  menuTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', openMenu);
  });

  if (menuClose) {
    menuClose.addEventListener('click', closeMenu);
  }

  menuLinks.forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* Menu sub-folder accordion */
  const folderTriggers = document.querySelectorAll('.menu-nav__folder-trigger');
  folderTriggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.menu-nav__item');
      const isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.menu-nav__item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        const t = el.querySelector('.menu-nav__folder-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Scroll reveal animations */
  const revealEls = document.querySelectorAll('.reveal');

  function stripRevealDelays(el) {
    // After the entrance settles, remove delay classes so transition-delay
    // doesn't leak into hover transitions on the same element.
    setTimeout(function () {
      el.classList.remove(
        'reveal-delay-1', 'reveal-delay-2', 'reveal-delay-3', 'reveal-delay-4',
        'reveal-delay-5', 'reveal-delay-6', 'reveal-delay-7', 'reveal-delay-8'
      );
    }, 1000);
  }

  if (revealEls.length > 0 && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            stripRevealDelays(entry.target);
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Sticky ATC bar — appears once buy block is out of view */
  const buyEl = document.querySelector('.pdp-buy');
  const stickyBar = document.querySelector('.sticky-atc');

  if (buyEl && stickyBar && 'IntersectionObserver' in window) {
    const atcObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );
    atcObserver.observe(buyEl);
  }

  /* Sticky ATC button — scroll to buy block or submit form */
  const stickyBtn = stickyBar ? stickyBar.querySelector('.sticky-atc__btn') : null;
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      const targetSel = stickyBtn.getAttribute('data-target') || '#buy';
      const target = document.querySelector(targetSel);
      const buyInView = target && target.getBoundingClientRect().top < window.innerHeight && target.getBoundingClientRect().bottom > 0;
      if (target && !buyInView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        const form = document.getElementById('product-form');
        if (form) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }
      }
    });
  }

  /* Product filter (PLP) */
  const filterPills   = document.querySelectorAll('.filter-pill');
  const productCards  = document.querySelectorAll('.product-card[data-category]');
  const productCountEl = document.querySelector('.plp-header__count');

  filterPills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      const filter = pill.getAttribute('data-filter');

      filterPills.forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');

      let visibleCount = 0;
      productCards.forEach(function (card) {
        const category = card.getAttribute('data-category');
        const show = filter === 'all' || (category && category.indexOf(filter) !== -1);
        card.classList.toggle('is-hidden', !show);
        if (show) visibleCount++;
      });

      if (productCountEl) {
        productCountEl.textContent = visibleCount + ' Product' + (visibleCount !== 1 ? 's' : '');
      }
    });
  });

  /* FAQ accordions */
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    const trigger = item.querySelector('.faq-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');
      faqItems.forEach(function (fi) {
        fi.classList.remove('is-open');
        const t = fi.querySelector('.faq-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* PDP accordions */
  const accordionItems = document.querySelectorAll('.accordion__item');
  accordionItems.forEach(function (item) {
    const trigger = item.querySelector('.accordion__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* Multi-option variant selector (PDP) — handles Size, Color, generic combined */
  const buySection = document.querySelector('.pdp-buy');
  if (buySection) {
    const variantDataEl = buySection.querySelector('[data-variant-data]');
    let variantData = [];
    if (variantDataEl) {
      try {
        variantData = JSON.parse(variantDataEl.textContent);
      } catch (err) {
        variantData = [];
      }
    }

    const variantInput = document.querySelector('input[name="id"]');
    const atcBtn = document.querySelector('.pdp-atc-btn');
    const priceEl = document.querySelector('[data-pdp-price]');
    const stickyPriceEl = document.querySelector('.sticky-atc__price');
    const optionRows = buySection.querySelectorAll('.pdp-buy__option-row');

    // Initial selected options derived from currently-selected buttons / swatches
    const selected = [];
    optionRows.forEach(function (row) {
      const idx = parseInt(row.getAttribute('data-option-index'), 10);
      const current = row.querySelector('.is-selected');
      if (current) {
        selected[idx] = current.getAttribute('data-option-value');
      }
    });

    function findVariant() {
      return variantData.find(function (v) {
        if (!v.options || v.options.length !== selected.length) return false;
        for (let i = 0; i < selected.length; i++) {
          if (selected[i] == null) return false;
          if (String(v.options[i]).toLowerCase().trim() !==
              String(selected[i]).toLowerCase().trim()) {
            return false;
          }
        }
        return true;
      });
    }

    function recomputeAvailability() {
      optionRows.forEach(function (row) {
        const idx = parseInt(row.getAttribute('data-option-index'), 10);
        const valEls = row.querySelectorAll('[data-option-value]');
        valEls.forEach(function (el) {
          const candidateValue = el.getAttribute('data-option-value');
          // Build a hypothetical selection: keep all OTHER options as currently selected,
          // set this index's value to candidate. If any variant matches and is available,
          // mark this element as available.
          const trial = selected.slice();
          trial[idx] = candidateValue;
          const match = variantData.find(function (v) {
            if (!v.options || v.options.length !== trial.length) return false;
            for (let i = 0; i < trial.length; i++) {
              if (trial[i] == null) continue; // unselected — treat as wildcard
              if (String(v.options[i]).toLowerCase().trim() !==
                  String(trial[i]).toLowerCase().trim()) {
                return false;
              }
            }
            return v.available;
          });
          el.classList.toggle('is-sold-out', !match);
        });
      });
    }

    function updateUI() {
      const variant = findVariant();
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      // Price
      if (priceEl) {
        priceEl.textContent = variant.price;
        priceEl.setAttribute('content', (variant.raw_price / 100).toFixed(2));
      }
      if (stickyPriceEl) stickyPriceEl.textContent = variant.price;

      // ATC button
      if (atcBtn) {
        const defaultLabel = atcBtn.getAttribute('data-atc-default') || 'Add to Cart';
        const soldOutLabel = atcBtn.getAttribute('data-atc-sold-out') || 'Sold Out';
        if (variant.available) {
          atcBtn.textContent = defaultLabel + ' — ' + variant.price;
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-disabled');
          atcBtn.removeAttribute('aria-disabled');
          atcBtn.setAttribute('aria-label', 'Add to cart');
        } else {
          atcBtn.textContent = soldOutLabel;
          atcBtn.disabled = true;
          atcBtn.classList.add('is-disabled');
          atcBtn.setAttribute('aria-disabled', 'true');
          atcBtn.setAttribute('aria-label', soldOutLabel + ' — not available');
        }
      }

      // Selected value display
      optionRows.forEach(function (row) {
        const idx = parseInt(row.getAttribute('data-option-index'), 10);
        const labelEl = row.querySelector('[data-selected-for="' + idx + '"]');
        if (labelEl && selected[idx] != null) labelEl.textContent = selected[idx];
      });
    }

    // Bind clicks on all interactive option buttons / swatches
    const optionInteractives = buySection.querySelectorAll('button.size-btn[data-option-value], button.color-swatch[data-option-value]');
    optionInteractives.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.classList.contains('is-sold-out') || btn.disabled) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        const idx = parseInt(btn.getAttribute('data-option-index'), 10);
        const value = btn.getAttribute('data-option-value');
        if (isNaN(idx) || !value) return;

        selected[idx] = value;

        // Mark selected within this option row (clear siblings, set this)
        const row = btn.closest('.pdp-buy__option-row');
        if (row) {
          row.querySelectorAll('.is-selected').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
        }

        updateUI();
        recomputeAvailability();
      });
    });

    // Initial availability pass (in case some sold-out states need adjusting at load)
    recomputeAvailability();
  }

  /* Size chart modal */
  const chartTriggers = document.querySelectorAll('[data-chart-trigger]');
  const chartModal = document.getElementById('size-chart-modal');
  if (chartTriggers.length > 0 && chartModal) {
    chartTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (typeof chartModal.showModal === 'function') {
          chartModal.showModal();
        } else {
          chartModal.setAttribute('open', '');
        }
      });
    });

    const chartCloses = chartModal.querySelectorAll('[data-chart-close]');
    chartCloses.forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (typeof chartModal.close === 'function') {
          chartModal.close();
        } else {
          chartModal.removeAttribute('open');
        }
      });
    });

    chartModal.addEventListener('click', function (e) {
      const rect = chartModal.getBoundingClientRect();
      const inside =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;
      if (!inside) {
        if (typeof chartModal.close === 'function') chartModal.close();
        else chartModal.removeAttribute('open');
      }
    });
  }

  /* Capture-phase guard — no click on a sold-out option can ever propagate */
  document.addEventListener('click', function (e) {
    const target = e.target.closest('.size-btn.is-sold-out, .color-swatch.is-sold-out');
    if (target) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* PDP Hero — click-to-zoom lightbox */
  const heroLightbox = document.getElementById('hero-lightbox');
  const heroImgsForZoom = document.querySelectorAll('.pdp-hero__img');
  if (heroLightbox && heroImgsForZoom.length > 0) {
    const lightboxImg = heroLightbox.querySelector('.hero-lightbox__img');
    const lightboxCounter = heroLightbox.querySelector('.hero-lightbox__counter');
    const lightboxPrev = heroLightbox.querySelector('[data-lightbox-prev]');
    const lightboxNext = heroLightbox.querySelector('[data-lightbox-next]');
    const lightboxClose = heroLightbox.querySelector('[data-lightbox-close]');
    const lightboxStage = heroLightbox.querySelector('.hero-lightbox__stage');

    const heroImgsArr = Array.from(heroImgsForZoom);
    const total = heroImgsArr.length;
    let currentZoomIndex = 0;

    function getHighResSrc(img) {
      const baseSrc = img.currentSrc || img.src;
      // Bump Shopify CDN width to 2400 for a sharper zoom
      return baseSrc.replace(/([?&])width=\d+/, '$1width=2400');
    }

    function showZoom(idx) {
      currentZoomIndex = ((idx % total) + total) % total;
      const sourceImg = heroImgsArr[currentZoomIndex];
      lightboxImg.src = getHighResSrc(sourceImg);
      lightboxImg.alt = sourceImg.alt || '';
      if (lightboxCounter) {
        lightboxCounter.textContent = (currentZoomIndex + 1) + ' / ' + total;
      }
      const onlyOne = total <= 1;
      if (lightboxPrev) lightboxPrev.style.display = onlyOne ? 'none' : '';
      if (lightboxNext) lightboxNext.style.display = onlyOne ? 'none' : '';
      if (lightboxCounter) lightboxCounter.style.display = onlyOne ? 'none' : '';
    }

    function openZoom(idx) {
      showZoom(idx);
      if (typeof heroLightbox.showModal === 'function') {
        heroLightbox.showModal();
      } else {
        heroLightbox.setAttribute('open', '');
      }
    }

    function closeZoom() {
      if (typeof heroLightbox.close === 'function') {
        heroLightbox.close();
      } else {
        heroLightbox.removeAttribute('open');
      }
    }

    // Bind click on each hero image — distinguish from drag
    heroImgsArr.forEach(function (img, idx) {
      let downX = 0;
      let downY = 0;
      img.addEventListener('mousedown', function (e) {
        downX = e.clientX;
        downY = e.clientY;
      });
      img.addEventListener('click', function (e) {
        const dx = Math.abs(e.clientX - downX);
        const dy = Math.abs(e.clientY - downY);
        if (dx > 6 || dy > 6) return;  // it was a drag, not a click
        e.preventDefault();
        openZoom(idx);
      });
    });

    if (lightboxPrev) lightboxPrev.addEventListener('click', function () { showZoom(currentZoomIndex - 1); });
    if (lightboxNext) lightboxNext.addEventListener('click', function () { showZoom(currentZoomIndex + 1); });
    if (lightboxClose) lightboxClose.addEventListener('click', closeZoom);
    if (lightboxStage) lightboxStage.addEventListener('click', function (e) {
      // Close when clicking the stage backdrop, but not the image itself
      if (e.target === lightboxStage) closeZoom();
    });

    // Keyboard arrow navigation while open
    heroLightbox.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') showZoom(currentZoomIndex - 1);
      if (e.key === 'ArrowRight') showZoom(currentZoomIndex + 1);
    });

    // Touch swipe navigation (mobile)
    if (lightboxStage) {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      const SWIPE_THRESHOLD = 50;     // horizontal pixels required to register as swipe
      const VERTICAL_LIMIT = 80;       // if vertical motion exceeds this, treat as scroll/dismiss, not swipe

      lightboxStage.addEventListener('touchstart', function (e) {
        const t = e.changedTouches[0];
        touchStartX = t.screenX;
        touchStartY = t.screenY;
      }, { passive: true });

      lightboxStage.addEventListener('touchend', function (e) {
        const t = e.changedTouches[0];
        touchEndX = t.screenX;
        touchEndY = t.screenY;
        const dx = touchEndX - touchStartX;
        const dy = touchEndY - touchStartY;
        if (Math.abs(dy) > VERTICAL_LIMIT) return;
        if (Math.abs(dx) < SWIPE_THRESHOLD) return;
        if (dx < 0) {
          showZoom(currentZoomIndex + 1); // swipe left → next
        } else {
          showZoom(currentZoomIndex - 1); // swipe right → prev
        }
      }, { passive: true });
    }
  }

  /* Featured kits (slim) — drag-to-scroll on desktop */
  const slimTrack = document.querySelector('.featured-kits-slim__grid');
  if (slimTrack) {
    let slimDragging = false;
    let slimStartX = 0;
    let slimScrollLeft = 0;
    slimTrack.addEventListener('mousedown', function (e) {
      slimDragging = true;
      slimStartX = e.pageX - slimTrack.offsetLeft;
      slimScrollLeft = slimTrack.scrollLeft;
      slimTrack.style.cursor = 'grabbing';
      slimTrack.style.userSelect = 'none';
    });
    slimTrack.addEventListener('mouseleave', function () {
      slimDragging = false;
      slimTrack.style.cursor = '';
      slimTrack.style.userSelect = '';
    });
    slimTrack.addEventListener('mouseup', function () {
      slimDragging = false;
      slimTrack.style.cursor = '';
      slimTrack.style.userSelect = '';
    });
    slimTrack.addEventListener('mousemove', function (e) {
      if (!slimDragging) return;
      e.preventDefault();
      slimTrack.scrollLeft = slimScrollLeft - ((e.pageX - slimTrack.offsetLeft) - slimStartX) * 1.5;
    });
  }

  /* PDP Hero gallery — horizontal scroll-snap with arrows, dots, drag */
  const heroTrack = document.querySelector('.pdp-hero__track');
  if (heroTrack) {
    const heroPrev = document.querySelector('.pdp-hero__arrow--prev');
    const heroNext = document.querySelector('.pdp-hero__arrow--next');
    const heroDots = document.querySelectorAll('.pdp-hero__dot');
    const heroSlides = heroTrack.querySelectorAll('.pdp-hero__slide');

    function heroSlideWidth() {
      const first = heroTrack.querySelector('.pdp-hero__slide');
      return first ? first.offsetWidth : heroTrack.offsetWidth;
    }

    if (heroPrev) {
      heroPrev.addEventListener('click', function () {
        heroTrack.scrollBy({ left: -heroSlideWidth(), behavior: 'smooth' });
      });
    }
    if (heroNext) {
      heroNext.addEventListener('click', function () {
        heroTrack.scrollBy({ left: heroSlideWidth(), behavior: 'smooth' });
      });
    }

    heroDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const idx = parseInt(dot.getAttribute('data-index'), 10);
        const target = heroSlides[idx];
        if (target) target.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
      });
    });

    if ('IntersectionObserver' in window && heroDots.length > 0) {
      const heroObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const idx = Array.from(heroSlides).indexOf(entry.target);
            if (idx >= 0) {
              heroDots.forEach(function (d, i) {
                const active = i === idx;
                d.classList.toggle('is-active', active);
                d.setAttribute('aria-selected', String(active));
              });
            }
          }
        });
      }, { root: heroTrack, threshold: 0.6 });
      heroSlides.forEach(function (s) { heroObs.observe(s); });
    }

    let heroDragging = false;
    let heroStartX = 0;
    let heroScrollLeft = 0;

    heroTrack.addEventListener('mousedown', function (e) {
      heroDragging = true;
      heroStartX = e.pageX - heroTrack.offsetLeft;
      heroScrollLeft = heroTrack.scrollLeft;
      heroTrack.style.cursor = 'grabbing';
      heroTrack.style.userSelect = 'none';
    });
    heroTrack.addEventListener('mouseleave', function () {
      heroDragging = false;
      heroTrack.style.cursor = '';
      heroTrack.style.userSelect = '';
    });
    heroTrack.addEventListener('mouseup', function () {
      heroDragging = false;
      heroTrack.style.cursor = '';
      heroTrack.style.userSelect = '';
    });
    heroTrack.addEventListener('mousemove', function (e) {
      if (!heroDragging) return;
      e.preventDefault();
      const x = e.pageX - heroTrack.offsetLeft;
      heroTrack.scrollLeft = heroScrollLeft - (x - heroStartX) * 1.5;
    });
  }

  /* Contact hero — topographic backdrop generator */
  const topoHost = document.querySelector('.contact-hero__topo');
  if (topoHost && topoHost.children.length === 0) {
    const W = 1600;
    const H = 600;
    const lineCount = 38;
    const samples = 96;
    const NS = 'http://www.w3.org/2000/svg';

    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('preserveAspectRatio', 'xMidYMax slice');

    function rand(min, max) { return min + Math.random() * (max - min); }

    for (let i = 0; i < lineCount; i++) {
      const t = i / (lineCount - 1);
      const baseY = 70 + t * (H - 100);
      const amp1 = rand(18, 55) * (0.4 + 0.6 * t);
      const amp2 = rand(8, 26) * (0.3 + 0.7 * t);
      const freq1 = rand(1.4, 2.6);
      const freq2 = rand(3.0, 5.5);
      const phase1 = rand(0, Math.PI * 2);
      const phase2 = rand(0, Math.PI * 2);

      let d = '';
      for (let s = 0; s <= samples; s++) {
        const x = (s / samples) * W;
        const u = s / samples;
        const y = baseY
          - Math.sin(u * Math.PI * freq1 + phase1) * amp1
          - Math.sin(u * Math.PI * freq2 + phase2) * amp2;
        d += (s === 0 ? 'M' : 'L') + x.toFixed(1) + ' ' + y.toFixed(1) + ' ';
      }

      const path = document.createElementNS(NS, 'path');
      path.setAttribute('d', d);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'rgba(255,255,255,0.55)');
      path.setAttribute('stroke-width', (0.5 + t * 0.4).toFixed(2));
      path.setAttribute('stroke-linecap', 'round');
      svg.appendChild(path);
    }

    topoHost.appendChild(svg);
  }

  /* PDP image gallery dots (mobile sync) */
  const galleryTrack = document.querySelector('.pdp__gallery-track');
  const galleryDots  = document.querySelectorAll('.gallery-dot');

  if (galleryTrack && galleryDots.length > 0) {
    const galleryImages = galleryTrack.querySelectorAll('.pdp__gallery-image');

    const dotObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const index = Array.from(galleryImages).indexOf(entry.target);
            galleryDots.forEach(function (d, i) {
              d.classList.toggle('is-active', i === index);
              d.setAttribute('aria-selected', String(i === index));
            });
          }
        });
      },
      { root: galleryTrack, threshold: 0.5 }
    );

    galleryImages.forEach(function (img) { dotObserver.observe(img); });

    galleryDots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        const target = galleryImages[i];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  }

  /* Nano carousel — horizontal scroller with drag, arrows, progress, edge fades */
  document.querySelectorAll('[data-nano-carousel]').forEach(function (wrapper) {
    const track = wrapper.querySelector('[data-nano-track]');
    const prevBtn = wrapper.querySelector('[data-nano-prev]');
    const nextBtn = wrapper.querySelector('[data-nano-next]');
    const progressBar = wrapper.querySelector('[data-nano-progress]');
    if (!track) return;

    function slideStep() {
      // .nano-carousel__slide for product carousels, [data-carousel-slide] for
      // other tracks reusing this controller (e.g. featured kits)
      const slide = track.querySelector('.nano-carousel__slide, [data-carousel-slide]');
      if (!slide) return track.clientWidth * 0.8;
      const gap = parseFloat(getComputedStyle(track).gap) || 20;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateState() {
      const max = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;
      const tolerance = 2;
      const atStart = x <= tolerance;
      const atEnd = x >= max - tolerance;
      const hasOverflow = max > tolerance;

      wrapper.classList.toggle('has-overflow-start', hasOverflow && !atStart);
      wrapper.classList.toggle('has-overflow-end', hasOverflow && !atEnd);

      if (prevBtn) prevBtn.disabled = !hasOverflow || atStart;
      if (nextBtn) nextBtn.disabled = !hasOverflow || atEnd;

      if (progressBar) {
        if (!hasOverflow) {
          progressBar.style.width = '100%';
          progressBar.style.transform = 'translateX(0)';
        } else {
          // Bar represents visible viewport relative to total scrollable content
          const visibleRatio = track.clientWidth / track.scrollWidth;
          const progress = max > 0 ? x / max : 0;
          progressBar.style.width = (visibleRatio * 100) + '%';
          progressBar.style.transform = 'translateX(' + (progress * (100 / visibleRatio - 100)) + '%)';
        }
      }
    }

    function scrollByStep(direction) {
      const step = slideStep();
      track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByStep(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByStep(1); });

    // Throttled scroll listener via rAF
    let scrollTicking = false;
    track.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        updateState();
        scrollTicking = false;
      });
    }, { passive: true });

    // Keyboard navigation when track is focused
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollByStep(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByStep(-1); }
      else if (e.key === 'Home') { e.preventDefault(); track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else if (e.key === 'End') { e.preventDefault(); track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); }
    });

    // Mouse drag-to-scroll (desktop)
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let didDrag = false;
    const DRAG_THRESHOLD = 5; // pixels before we treat as drag (suppress clicks)

    track.addEventListener('mousedown', function (e) {
      // Only left mouse button, and not on form controls
      if (e.button !== 0) return;
      isDown = true;
      didDrag = false;
      startX = e.pageX;
      startScrollLeft = track.scrollLeft;
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      const dx = e.pageX - startX;
      if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
        track.classList.add('is-dragging');
      }
      if (didDrag) {
        e.preventDefault();
        track.scrollLeft = startScrollLeft - dx;
      }
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      if (didDrag) {
        // Re-enable snap; snap to nearest slide
        track.classList.remove('is-dragging');
        const step = slideStep();
        const target = Math.round(track.scrollLeft / step) * step;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
    }

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);

    // Suppress click on cards when we just finished a drag
    track.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);

    // Recompute on resize and after images load
    let resizeTicking = false;
    window.addEventListener('resize', function () {
      if (resizeTicking) return;
      resizeTicking = true;
      requestAnimationFrame(function () {
        updateState();
        resizeTicking = false;
      });
    });

    track.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', updateState, { once: true });
    });

    updateState();
  });

  /* Hero statement — drifts down at a fraction of the scroll rate (Hopaal-style).
     Transform goes on the blending text spans themselves: transforming the
     container would isolate the stacking context and kill mix-blend-mode. */
  const heroStatement = document.querySelector('[data-hero-statement]');
  const heroSection = document.querySelector('.hero--statement');

  // Load-in sequence: statement lines mask-rise + hero image settles from zoom.
  // The class flips CSS transitions; drift writing is gated until the entrance finishes
  // so the inline transform doesn't stomp the CSS entrance transform.
  let heroDriftReady = false;
  if (heroSection) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      heroSection.classList.add('hero--loaded');
      heroSection.classList.add('hero--drift-ready');
      heroDriftReady = true;
    } else {
      setTimeout(function () { heroSection.classList.add('hero--loaded'); }, 100);
      setTimeout(function () {
        heroDriftReady = true;
        // Releases the entrance mask (overflow) + transition so drift is unclipped
        heroSection.classList.add('hero--drift-ready');
      }, 1500);
    }
  } else {
    heroDriftReady = true;
  }

  if (heroStatement && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const heroStFactor = parseFloat(heroStatement.getAttribute('data-parallax')) || 0;
    const heroStTexts = heroStatement.querySelectorAll('[data-hero-statement-text]');
    // Smoothed drift (Lenis-style lerp): scroll only sets a target; a rAF loop
    // eases the text toward it. Wheel scrolling is stepped, so writing the
    // position straight from the scroll event looks jittery — the easing
    // absorbs the steps and adds the floaty trail the reference has.
    let heroStTarget = 0;
    let heroStCurrent = 0;
    let heroStRaf = null;
    // Mobile: shorter viewport + flicky touch scrolling makes the same drift
    // factor feel rushed — scale it down
    const driftMobileMq = window.matchMedia('(max-width: 767px)');

    function heroStTick() {
      heroStCurrent += (heroStTarget - heroStCurrent) * (driftMobileMq.matches ? 0.045 : 0.06);
      if (Math.abs(heroStTarget - heroStCurrent) < 0.05) {
        heroStCurrent = heroStTarget;
        heroStRaf = null;
      } else {
        heroStRaf = requestAnimationFrame(heroStTick);
      }
      const ty = heroStCurrent.toFixed(2);
      heroStTexts.forEach(function (el) {
        el.style.transform = 'translate3d(0,' + ty + 'px,0)';
      });
    }

    function heroStOnScroll() {
      if (!heroDriftReady) return;
      // Past 1.5 viewport heights the hero is long gone — clamp instead of
      // freezing so the easing can still settle cleanly
      const limit = (window.innerHeight || 800) * 1.5;
      const f = heroStFactor * (driftMobileMq.matches ? 0.4 : 1);
      heroStTarget = Math.min(window.scrollY || 0, limit) * f;
      if (heroStRaf === null) heroStRaf = requestAnimationFrame(heroStTick);
    }

    if (heroStFactor > 0 && heroStTexts.length > 0) {
      window.addEventListener('scroll', heroStOnScroll, { passive: true });
      // Sync once the entrance gate opens (covers scrolling during the load-in)
      setTimeout(heroStOnScroll, 1550);
    }
  }

  /* Footer uncover — fixed footer behind the page; body reserves scroll runway */
  const uncoverFooter = document.querySelector('.site-footer');
  const pageMain = document.querySelector('main.page-content');
  if (uncoverFooter && pageMain && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.body.classList.add('has-footer-uncover');
    let footerMeasureTick = false;

    function measureFooter() {
      const h = uncoverFooter.offsetHeight;
      document.body.style.marginBottom = h + 'px';
      footerMeasureTick = false;
    }

    measureFooter();
    // Re-measure after fonts/images settle, and on resize
    setTimeout(measureFooter, 800);
    window.addEventListener('load', measureFooter);
    window.addEventListener('resize', function () {
      if (footerMeasureTick) return;
      footerMeasureTick = true;
      requestAnimationFrame(measureFooter);
    });
  }

  /* Category tile parallax — JS drives --par; hover zoom stays in CSS via --tile-zoom */
  const parallaxTiles = document.querySelectorAll('[data-parallax-bg]');
  if (parallaxTiles.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let tileTicking = false;

    function updateTileParallax() {
      const vh = window.innerHeight || 1;
      parallaxTiles.forEach(function (tile) {
        const rect = tile.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        const centerOffset = (rect.top + rect.height / 2) - vh / 2; // px from viewport center
        const par = Math.max(-rect.height * 0.08, Math.min(rect.height * 0.08, centerOffset * -0.06));
        const bg = tile.querySelector('.category-tile__bg');
        if (bg) bg.style.setProperty('--par', par.toFixed(1) + 'px');
      });
      tileTicking = false;
    }

    window.addEventListener('scroll', function () {
      if (tileTicking) return;
      tileTicking = true;
      requestAnimationFrame(updateTileParallax);
    }, { passive: true });
    updateTileParallax();
  }

  /* Blend statement — Hopaal hero behavior: text sits centered while the
     section is in view; once the section starts scrolling out past the top,
     the lines lag hard behind the scroll (near-pinned in the viewport), so
     they ride down the full length of the image and finally slide out
     through the section's bottom edge (overflow:hidden does the clipping).
     Transform goes on the spans; transforming a wrapper would kill
     mix-blend-mode. */
  const blendStatements = document.querySelectorAll('[data-blend-statement]');
  if (blendStatements.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    // Same smoothed-lerp approach as the hero statement (see above)
    const blendItems = [];
    blendStatements.forEach(function (sec) {
      blendItems.push({
        sec: sec,
        lines: sec.querySelectorAll('[data-blend-line]'),
        factor: parseFloat(sec.getAttribute('data-parallax')) || 0,
        current: 0,
        target: 0
      });
    });
    let blendRaf = null;
    // Same mobile drift scaling as the hero statement
    const blendMobileMq = window.matchMedia('(max-width: 767px)');

    function blendTick() {
      let active = false;
      blendItems.forEach(function (it) {
        const delta = it.target - it.current;
        if (Math.abs(delta) < 0.05) {
          it.current = it.target;
        } else {
          it.current += delta * (blendMobileMq.matches ? 0.045 : 0.06);
          active = true;
        }
        const ty = it.current.toFixed(2);
        it.lines.forEach(function (line) {
          line.style.transform = 'translate3d(0,' + ty + 'px,0)';
        });
      });
      blendRaf = active ? requestAnimationFrame(blendTick) : null;
    }

    function blendOnScroll() {
      const vh = window.innerHeight || 1;
      blendItems.forEach(function (it) {
        const rect = it.sec.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return; // off-screen: keep last target
        it.target = Math.max(0, -rect.top) * it.factor * (blendMobileMq.matches ? 0.4 : 1);
      });
      if (blendRaf === null) blendRaf = requestAnimationFrame(blendTick);
    }

    window.addEventListener('scroll', blendOnScroll, { passive: true });
    blendOnScroll();
  }

  /* Nano carousel — tab switcher */
  document.querySelectorAll('.nano-carousel').forEach(function (section) {
    const tabs = section.querySelectorAll('[data-tab-index]');
    const panels = section.querySelectorAll('[data-tab-panel-index]');
    const viewAllLink = section.querySelector('[data-nano-view-all]');
    if (tabs.length === 0) return;

    const viewAllOverride = viewAllLink && viewAllLink.getAttribute('data-view-all-override') === 'true';

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const idx = tab.getAttribute('data-tab-index');

        tabs.forEach(function (t) {
          const isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          const isActive = p.getAttribute('data-tab-panel-index') === idx;
          p.classList.toggle('is-active', isActive);
          if (isActive) {
            // Re-measure the newly-visible carousel — measurements were 0 while display:none
            const track = p.querySelector('[data-nano-track]');
            if (track) {
              track.scrollLeft = 0;
              track.dispatchEvent(new Event('scroll'));
            }
          }
        });

        if (viewAllLink && !viewAllOverride) {
          const url = tab.getAttribute('data-view-all-url');
          if (url) viewAllLink.setAttribute('href', url);
        }
      });
    });
  });

  /* Product card — quick add to cart */
  function refreshHeaderCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.header__cart-count').forEach(function (el) {
          el.textContent = 'P (' + cart.item_count + ')';
        });
        document.querySelectorAll('.header__icon-link[aria-label^="Cart"]').forEach(function (el) {
          el.setAttribute('aria-label', 'Cart — ' + cart.item_count + ' items');
        });
      })
      .catch(function () {});
  }

  /* ============================================================
     Cart drawer — AJAX slide-out with free-shipping progress
     ============================================================ */
  const cartDrawer = document.getElementById('unvxt-cart-drawer');

  function escapeCartHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCartDrawer(cart) {
    if (!cartDrawer || !cart) return;
    const itemsEl = cartDrawer.querySelector('[data-unvxt-cart-items]');
    const emptyEl = cartDrawer.querySelector('[data-unvxt-cart-empty]');
    const footerEl = cartDrawer.querySelector('[data-unvxt-cart-footer]');
    const countEl = cartDrawer.querySelector('[data-unvxt-cart-count]');
    const subtotalEl = cartDrawer.querySelector('[data-unvxt-cart-subtotal]');

    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    if (subtotalEl) subtotalEl.textContent = '$' + (cart.items_subtotal_price / 100).toFixed(2);

    const isEmpty = cart.item_count === 0;
    if (emptyEl) emptyEl.hidden = !isEmpty;
    if (footerEl) footerEl.hidden = isEmpty;
    if (itemsEl) itemsEl.style.display = isEmpty ? 'none' : '';

    // Free-shipping progress
    const shipbar = cartDrawer.querySelector('[data-unvxt-cart-shipbar]');
    if (shipbar) {
      const threshold = parseInt(cartDrawer.getAttribute('data-fs-threshold'), 10) || 13000;
      const textEl = shipbar.querySelector('[data-unvxt-cart-shipbar-text]');
      const fillEl = shipbar.querySelector('[data-unvxt-cart-shipbar-fill]');
      const subtotal = cart.items_subtotal_price;
      const pct = Math.min(100, (subtotal / threshold) * 100);
      if (fillEl) fillEl.style.width = pct + '%';
      if (textEl) {
        if (subtotal >= threshold) {
          shipbar.classList.add('is-unlocked');
          textEl.innerHTML = '&#10003; Free shipping unlocked';
        } else {
          shipbar.classList.remove('is-unlocked');
          const away = ((threshold - subtotal) / 100).toFixed(2);
          textEl.innerHTML = "You're <strong>$" + away + '</strong> away from free shipping';
        }
      }
    }

    if (!itemsEl) return;
    if (isEmpty) { itemsEl.innerHTML = ''; return; }

    let html = '';
    cart.items.forEach(function (item) {
      let img = item.image || '';
      if (img.indexOf('//') === 0) img = 'https:' + img;
      if (img) {
        const sep = img.indexOf('?') > -1 ? '&' : '?';
        img = img + sep + 'width=160';
      }
      const variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      html +=
        '<div class="unvxt-cart__item" data-line-key="' + escapeCartHtml(item.key) + '">' +
          (img ? '<img class="unvxt-cart__item-img" src="' + img + '" alt="" loading="lazy" decoding="async">' : '<span class="unvxt-cart__item-img"></span>') +
          '<div class="unvxt-cart__item-info">' +
            '<a class="unvxt-cart__item-title" href="' + escapeCartHtml(item.url) + '">' + escapeCartHtml(item.product_title) + '</a>' +
            (variantLabel ? '<p class="unvxt-cart__item-variant">' + escapeCartHtml(variantLabel) + '</p>' : '') +
            '<div class="unvxt-cart__qty">' +
              '<button type="button" class="unvxt-cart__qty-btn" data-cart-qty-down aria-label="Decrease quantity">&minus;</button>' +
              '<span class="unvxt-cart__qty-num">' + item.quantity + '</span>' +
              '<button type="button" class="unvxt-cart__qty-btn" data-cart-qty-up aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="unvxt-cart__item-side">' +
            '<p class="unvxt-cart__item-price">$' + (item.final_line_price / 100).toFixed(2) + '</p>' +
            '<button type="button" class="unvxt-cart__item-remove" data-cart-remove>Remove</button>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    fetchCart().then(function (cart) {
      renderCartDrawer(cart);
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function changeCartLine(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart) {
          renderCartDrawer(cart);
          refreshHeaderCartCount();
        }
      });
  }

  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-unvxt-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });

    // Qty +/− and remove (delegated)
    cartDrawer.addEventListener('click', function (e) {
      const itemEl = e.target.closest('.unvxt-cart__item');
      if (!itemEl) return;
      const key = itemEl.getAttribute('data-line-key');
      const qtyEl = itemEl.querySelector('.unvxt-cart__qty-num');
      const currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;

      if (e.target.closest('[data-cart-remove]')) {
        changeCartLine(key, 0);
      } else if (e.target.closest('[data-cart-qty-up]')) {
        changeCartLine(key, currentQty + 1);
      } else if (e.target.closest('[data-cart-qty-down]')) {
        changeCartLine(key, Math.max(0, currentQty - 1));
      }
    });

    // Header cart icon opens drawer instead of navigating (href stays as no-JS fallback)
    document.querySelectorAll('.header__icon-link[aria-label^="Cart"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.getAttribute('aria-hidden') === 'false') closeCartDrawer();
    });

    // PDP buy form — intercept native submit, AJAX add, open drawer.
    // On any failure, fall back to native submit so checkout is never blocked.
    const pdpForm = document.getElementById('product-form');
    if (pdpForm) {
      pdpForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const fd = new FormData(pdpForm);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add_failed');
            return r.json();
          })
          .then(function () {
            refreshHeaderCartCount();
            openCartDrawer();
          })
          .catch(function () {
            pdpForm.submit();
          });
      });
    }
  }

  /* ============================================================
     Search overlay — predictive results via /search/suggest.json
     ============================================================ */
  const searchOverlay = document.getElementById('unvxt-search-overlay');
  if (searchOverlay) {
    const searchInput = searchOverlay.querySelector('[data-unvxt-search-input]');
    const resultsWrap = searchOverlay.querySelector('[data-unvxt-search-results]');
    const resultsGrid = searchOverlay.querySelector('[data-unvxt-search-grid]');
    const noneEl = searchOverlay.querySelector('[data-unvxt-search-none]');
    const allLink = searchOverlay.querySelector('[data-unvxt-search-all]');
    let searchTimer = null;
    let searchSeq = 0;

    function openSearch() {
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
    }
    function closeSearch() {
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-unvxt-search-open]').forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });
    searchOverlay.querySelectorAll('[data-unvxt-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay.getAttribute('aria-hidden') === 'false') closeSearch();
    });

    function runSearch(query) {
      const seq = ++searchSeq;
      const url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (seq !== searchSeq) return; // stale response
          const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (allLink) allLink.setAttribute('href', '/search?q=' + encodeURIComponent(query));
          if (products.length === 0) {
            if (resultsWrap) resultsWrap.hidden = true;
            if (noneEl) noneEl.hidden = false;
            return;
          }
          if (noneEl) noneEl.hidden = true;
          let html = '';
          products.forEach(function (p) {
            let img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            if (img && img.indexOf('//') === 0) img = 'https:' + img;
            if (img) {
              const sep = img.indexOf('?') > -1 ? '&' : '?';
              img = img + sep + 'width=400';
            }
            html +=
              '<a class="unvxt-search__result" href="' + escapeCartHtml(p.url) + '">' +
                (img ? '<img src="' + img + '" alt="' + escapeCartHtml(p.title) + '" loading="lazy" decoding="async">' : '') +
                '<p class="unvxt-search__result-title">' + escapeCartHtml(p.title) + '</p>' +
                '<p class="unvxt-search__result-price">$' + p.price + '</p>' +
              '</a>';
          });
          if (resultsGrid) resultsGrid.innerHTML = html;
          if (resultsWrap) resultsWrap.hidden = false;
        })
        .catch(function () {});
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        const q = searchInput.value.trim();
        clearTimeout(searchTimer);
        if (q.length < 2) {
          if (resultsWrap) resultsWrap.hidden = true;
          if (noneEl) noneEl.hidden = true;
          return;
        }
        searchTimer = setTimeout(function () { runSearch(q); }, 250);
      });
    }
  }

  /* Quick-add modal */
  const quickAddModal = document.getElementById('quick-add-modal');
  const quickAddState = {
    product: null,
    selected: [],
    productCache: {},
    qty: 1,
    activeSlide: 0
  };
  const QUICK_ADD_MAX_QTY = 10;

  function quickAddOpen() {
    if (!quickAddModal) return;
    if (typeof quickAddModal.showModal === 'function') {
      quickAddModal.showModal();
    } else {
      quickAddModal.setAttribute('open', '');
    }
    quickAddModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function quickAddClose() {
    if (!quickAddModal) return;
    if (typeof quickAddModal.close === 'function') {
      quickAddModal.close();
    } else {
      quickAddModal.removeAttribute('open');
    }
    quickAddModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    quickAddModal.style.transform = '';
    quickAddModal.classList.remove('is-dragging');
    quickAddState.product = null;
    quickAddState.selected = [];
    quickAddState.qty = 1;
    const qtyInput = quickAddModal.querySelector('[data-qty-input]');
    if (qtyInput) qtyInput.value = '1';
  }

  function quickAddFindVariant() {
    if (!quickAddState.product) return null;
    return quickAddState.product.variants.find(function (v) {
      for (let i = 0; i < quickAddState.selected.length; i++) {
        const sel = quickAddState.selected[i];
        if (sel == null) return false;
        const optVal = v['option' + (i + 1)];
        if (String(optVal).toLowerCase().trim() !== String(sel).toLowerCase().trim()) {
          return false;
        }
      }
      return true;
    });
  }

  function quickAddVariantAvailableFor(idx, candidateValue) {
    if (!quickAddState.product) return false;
    return quickAddState.product.variants.some(function (v) {
      if (!v.available) return false;
      for (let i = 0; i < quickAddState.product.options.length; i++) {
        if (i === idx) {
          if (String(v['option' + (i + 1)]).toLowerCase().trim() !== String(candidateValue).toLowerCase().trim()) return false;
        } else if (quickAddState.selected[i] != null) {
          if (String(v['option' + (i + 1)]).toLowerCase().trim() !== String(quickAddState.selected[i]).toLowerCase().trim()) return false;
        }
      }
      return true;
    });
  }

  function quickAddUpdateUI() {
    if (!quickAddState.product) return;

    quickAddModal.querySelectorAll('.quick-add__opt-btn').forEach(function (btn) {
      const idx = parseInt(btn.getAttribute('data-option-index'), 10);
      const val = btn.getAttribute('data-option-value');
      btn.classList.toggle('is-selected', quickAddState.selected[idx] === val);
      btn.classList.toggle('is-sold-out', !quickAddVariantAvailableFor(idx, val));
    });

    quickAddModal.querySelectorAll('[data-selected-for]').forEach(function (el) {
      const idx = parseInt(el.getAttribute('data-selected-for'), 10);
      el.textContent = quickAddState.selected[idx] || '';
    });

    const variant = quickAddFindVariant();
    const priceEl = quickAddModal.querySelector('[data-quick-add-price]');
    const submitBtn = quickAddModal.querySelector('[data-quick-add-submit]');
    const submitLabel = quickAddModal.querySelector('[data-quick-add-submit-label]');

    if (variant) {
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (variant.available) {
        submitBtn.disabled = false;
        submitLabel.textContent = 'Add to Cart';
      } else {
        submitBtn.disabled = true;
        submitLabel.textContent = 'Sold Out';
      }
    } else {
      submitBtn.disabled = true;
      submitLabel.textContent = 'Select options';
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function isColorOption(name) {
    const n = String(name || '').toLowerCase();
    return n === 'color' || n === 'colour';
  }

  function colorToSwatch(value) {
    const v = String(value || '').toLowerCase().trim();
    const map = {
      black: '#000000', white: '#ffffff', grey: '#808080', gray: '#808080',
      red: '#C0392B', blue: '#1F3A93', navy: '#1a2540', green: '#2E7D32',
      olive: '#556b2f', tan: '#D2B48C', brown: '#5C4033', beige: '#dcc9a3',
      cream: '#f5f0e1', charcoal: '#36454F', sand: '#c2b280'
    };
    return map[v] || v;
  }

  function findVariantImage(product, optionIdx, value) {
    const target = String(value).toLowerCase().trim();
    const variant = product.variants.find(function (v) {
      return v.featured_image && v.featured_image.src &&
        String(v['option' + (optionIdx + 1)]).toLowerCase().trim() === target;
    });
    if (!variant) return null;
    let src = variant.featured_image.src;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    const sep = src.indexOf('?') > -1 ? '&' : '?';
    return src + sep + 'width=80&height=80&crop=center';
  }

  function quickAddRender(product) {
    quickAddState.product = product;
    quickAddState.selected = (product.options || []).map(function () { return null; });

    const firstAvailable = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    if (firstAvailable) {
      (product.options || []).forEach(function (_opt, i) {
        quickAddState.selected[i] = firstAvailable['option' + (i + 1)];
      });
    }

    const imgEl = quickAddModal.querySelector('[data-quick-add-image]');
    const title = quickAddModal.querySelector('[data-quick-add-title]');
    const category = quickAddModal.querySelector('[data-quick-add-category]');
    const optionsContainer = quickAddModal.querySelector('[data-quick-add-options]');
    const links = quickAddModal.querySelectorAll('[data-quick-add-link]');
    const errorEl = quickAddModal.querySelector('[data-quick-add-error]');
    const qtyInput = quickAddModal.querySelector('[data-qty-input]');

    // Set single product image (server-side square crop strips any white margins)
    if (imgEl) {
      const firstSrc = product.featured_image || (product.images && product.images[0]) || '';
      let url = typeof firstSrc === 'string' ? firstSrc : '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      if (url) {
        const sep = url.indexOf('?') > -1 ? '&' : '?';
        imgEl.src = url + sep + 'width=900&height=900&crop=center';
      } else {
        imgEl.removeAttribute('src');
      }
      imgEl.alt = product.title;
    }

    // Reset quantity
    quickAddState.qty = 1;
    if (qtyInput) qtyInput.value = '1';

    if (title) title.textContent = product.title;
    if (category) category.textContent = product.type || (product.tags && product.tags[0]) || '';
    links.forEach(function (link) {
      link.setAttribute('href', '/products/' + product.handle);
    });
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    // Render option rows
    optionsContainer.innerHTML = '';
    (product.options || []).forEach(function (opt, idx) {
      const optionName = typeof opt === 'string' ? opt : opt.name;
      const optionValues = typeof opt === 'string'
        ? Array.from(new Set(product.variants.map(function (v) { return v['option' + (idx + 1)]; })))
        : (opt.values || []);

      const row = document.createElement('div');
      row.className = 'quick-add__option-row';
      row.setAttribute('data-option-index', String(idx));

      const isColor = isColorOption(optionName);

      const label = document.createElement('div');
      label.className = 'quick-add__option-label';
      label.innerHTML = '<span>' + escapeHtml(optionName) + '</span>' +
        '<span class="quick-add__option-label-selected" data-selected-for="' + idx + '"></span>';
      row.appendChild(label);

      const valuesEl = document.createElement('div');
      valuesEl.className = 'quick-add__option-values';

      optionValues.forEach(function (val) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quick-add__opt-btn' + (isColor ? ' quick-add__opt-btn--swatch' : '');
        btn.setAttribute('data-option-index', String(idx));
        btn.setAttribute('data-option-value', val);
        btn.setAttribute('aria-label', optionName + ': ' + val);
        if (isColor) {
          const variantImg = findVariantImage(product, idx, val);
          if (variantImg) {
            btn.style.backgroundImage = 'url("' + variantImg + '")';
            btn.style.backgroundSize = 'cover';
            btn.style.backgroundPosition = 'center';
            btn.classList.add('quick-add__opt-btn--swatch-image');
          } else {
            btn.style.background = colorToSwatch(val);
          }
          btn.title = val;
        } else {
          btn.textContent = val;
        }
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-sold-out')) return;
          quickAddState.selected[idx] = val;
          quickAddUpdateUI();
        });
        valuesEl.appendChild(btn);
      });

      row.appendChild(valuesEl);
      optionsContainer.appendChild(row);
    });

    quickAddUpdateUI();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function quickAddOpenForProduct(productUrl) {
    if (!quickAddModal) return;
    if (quickAddState.productCache[productUrl]) {
      quickAddRender(quickAddState.productCache[productUrl]);
      quickAddOpen();
      return;
    }
    const jsonUrl = productUrl.split('?')[0].replace(/\/$/, '') + '.js';
    fetch(jsonUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product_fetch_failed'); return r.json(); })
      .then(function (product) {
        quickAddState.productCache[productUrl] = product;
        quickAddRender(product);
        quickAddOpen();
      })
      .catch(function () {
        window.location.href = productUrl;
      });
  }

  if (quickAddModal) {
    quickAddModal.querySelectorAll('[data-quick-add-close]').forEach(function (el) {
      el.addEventListener('click', quickAddClose);
    });
    quickAddModal.addEventListener('click', function (e) {
      if (e.target === quickAddModal) quickAddClose();
    });
    quickAddModal.addEventListener('close', function () {
      quickAddModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });

    const submitBtn = quickAddModal.querySelector('[data-quick-add-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        const variant = quickAddFindVariant();
        const errorEl = quickAddModal.querySelector('[data-quick-add-error]');
        const submitLabel = quickAddModal.querySelector('[data-quick-add-submit-label]');
        if (!variant || !variant.available || submitBtn.disabled) return;

        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        const qtyToAdd = Math.max(1, parseInt(quickAddState.qty, 10) || 1);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: qtyToAdd })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            refreshHeaderCartCount();
            submitBtn.classList.remove('is-loading');
            submitBtn.classList.add('is-added');
            submitLabel.textContent = 'Added ✓';
            setTimeout(function () {
              quickAddClose();
              submitBtn.classList.remove('is-added');
              submitBtn.disabled = false;
              openCartDrawer();
            }, 900);
          })
          .catch(function (err) {
            submitBtn.classList.remove('is-loading');
            submitBtn.disabled = false;
            if (errorEl) {
              errorEl.textContent = (err && err.description) || 'Could not add to cart. Please try again.';
              errorEl.hidden = false;
            }
          });
      });
    }

    // Quantity stepper
    const qtyInput = quickAddModal.querySelector('[data-qty-input]');
    const qtyDown = quickAddModal.querySelector('[data-qty-down]');
    const qtyUp = quickAddModal.querySelector('[data-qty-up]');
    function setQty(n) {
      const next = Math.min(QUICK_ADD_MAX_QTY, Math.max(1, n));
      quickAddState.qty = next;
      if (qtyInput) qtyInput.value = String(next);
      if (qtyDown) qtyDown.disabled = next <= 1;
      if (qtyUp) qtyUp.disabled = next >= QUICK_ADD_MAX_QTY;
    }
    if (qtyDown) qtyDown.addEventListener('click', function () { setQty(quickAddState.qty - 1); });
    if (qtyUp) qtyUp.addEventListener('click', function () { setQty(quickAddState.qty + 1); });
    setQty(1);

    // Drag-to-dismiss on mobile
    const handleEl = quickAddModal.querySelector('[data-quick-add-handle]');
    const mediaEl = quickAddModal.querySelector('[data-quick-add-media]');
    const detailsEl = quickAddModal.querySelector('[data-quick-add-details]');
    if (handleEl) {
      let dragActive = false;
      let dragStartY = 0;
      let dragLastY = 0;
      let dragLastT = 0;
      let dragVelocity = 0;
      let dragCurrent = 0;
      let dragRAF = false;

      function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }

      function onPointerDown(e) {
        if (!isMobile()) return;
        // Only allow drag-to-dismiss from the handle or the media area (and only when details are at top)
        const fromHandle = e.target.closest('[data-quick-add-handle]');
        const fromMedia = e.target.closest('[data-quick-add-media]');
        if (!fromHandle && !fromMedia) return;
        if (detailsEl && detailsEl.scrollTop > 0) return;
        dragActive = true;
        dragStartY = e.clientY;
        dragLastY = e.clientY;
        dragLastT = performance.now();
        dragVelocity = 0;
        dragCurrent = 0;
        quickAddModal.classList.add('is-dragging');
        quickAddModal.style.willChange = 'transform';
      }

      function onPointerMove(e) {
        if (!dragActive) return;
        const dy = e.clientY - dragStartY;
        if (dy <= 0) {
          dragCurrent = 0;
        } else {
          dragCurrent = dy;
          const now = performance.now();
          const dt = now - dragLastT;
          if (dt > 0) dragVelocity = (e.clientY - dragLastY) / dt;
          dragLastY = e.clientY;
          dragLastT = now;
        }
        if (dragRAF) return;
        dragRAF = true;
        requestAnimationFrame(function () {
          quickAddModal.style.transform = 'translate3d(0,' + dragCurrent + 'px,0)';
          dragRAF = false;
        });
      }

      function onPointerUp() {
        if (!dragActive) return;
        dragActive = false;
        quickAddModal.classList.remove('is-dragging');
        const dismiss = dragCurrent > 100 || dragVelocity > 0.5;
        if (dismiss) {
          quickAddModal.style.transform = 'translate3d(0,100%,0)';
          setTimeout(function () {
            quickAddModal.style.willChange = '';
            quickAddClose();
          }, 220);
        } else {
          quickAddModal.style.transform = '';
          quickAddModal.style.willChange = '';
        }
      }

      quickAddModal.addEventListener('pointerdown', onPointerDown, { passive: true });
      quickAddModal.addEventListener('pointermove', onPointerMove, { passive: true });
      quickAddModal.addEventListener('pointerup', onPointerUp, { passive: true });
      quickAddModal.addEventListener('pointercancel', onPointerUp, { passive: true });
    }
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-product-card-atc]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;

    const hasOptions = btn.getAttribute('data-has-options') === 'true';
    const productUrl = btn.getAttribute('data-product-url');
    const variantId = btn.getAttribute('data-variant-id');

    if (hasOptions) {
      if (productUrl) quickAddOpenForProduct(productUrl);
      return;
    }

    if (!variantId) return;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function () {
        btn.classList.add('is-added');
        refreshHeaderCartCount();
        openCartDrawer();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1400);
      })
      .catch(function () {
        btn.disabled = false;
        if (productUrl) window.location.href = productUrl;
      });
  });

})();
